// Internal Dependencies
import { Subtitle } from 'components/shared';

// Local Dependencies
import AdminPortalsTable from './AdminPortalsTable';

// Component Definition
const AdminPortals = () => {
  return (
    <>
      <Subtitle>
        Admin Portals
      </Subtitle>

      <AdminPortalsTable />
    </>
  );
};

export default AdminPortals;
